import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import Icon from 'components/UI/Icon';
import AdvantagesList from './AdvantagesList';
import BenefitsList from './BenefitsList';

import useIntersection from 'hooks/useIntersection';
import { MOBILE_KEY } from '@/constants/devices.js';
import useDeviceState from '@/hooks/useDeviceState';

import * as styles from './cloud.module.scss';

const Cloud = ({ data }) => {
  const deviceState = useDeviceState();

  const advantages = data.advantages_list;
  const benefits = data.benefits_list;

  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.5,
  });

  return (
    <section className={classnames(styles.section)} ref={scrollWrapper}>
      <div className="cr-wrap">
        <div
          className={classnames(styles.content, inViewSec && styles.jsAnimInit)}
          ref={inViewRefSec}
        >
          <h2
            className={classnames(
              styles.title,
              'cr-h2 cr-underline-gradient cr-underline-gradient--large'
            )}
          >
            <span className={classnames('cr-gradient')}>
              {data.title.markered && data.title.markered}
            </span>
            {data.title.default && data.title.default}
          </h2>

          <AdvantagesList data={advantages} />
          <BenefitsList data={benefits} />
        </div>

        <div className={classnames(styles.extra)}>
          {data.button.text && (
            <Link
              to={data.button.url}
              className={classnames(
                styles.link,
                'cr-btn cr-btn--large cr-btn--wide cr-btn--icon cr-btn--icon-red-txt'
              )}
            >
              {deviceState !== MOBILE_KEY ? data.button.text : 'Learn more'}

              <Icon name="corner-arrow-small-bold" />
            </Link>
          )}

          <picture className={classnames(styles.logo, 'cr-opacity-05')}>
            {data.partner_logo && <img src={data.partner_logo} alt="" />}
          </picture>
        </div>
      </div>
    </section>
  );
};

export default Cloud;
